import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'searchNative',
    standalone: false,
})
export class SearchNativePipe implements PipeTransform {
    transform (collection: any, searchField:string, searchValue: any): any {
        if (!Array.isArray(collection) || !searchField || !searchValue) {
            return collection;
        }

        const searchTerm = String(searchValue).toLowerCase();

        return collection.filter((member) => {
            const fieldValue = member[searchField];
            if (fieldValue === null || fieldValue === undefined) {
                return false;
            }
            return String(fieldValue).toLowerCase().includes(searchTerm);
        });
    }
}
